"use client";
import React from "react";
import Link from "next/link";
import OptimizedImage from "../common/OptimizedImage";

export default function AssetiloDashboard() {
  const handleRequestDemo = () => {
    window.open("https://form.typeform.com/to/w6upDqu2", "_blank");
  };

  const scrollToAIAgents = () => {
    const element = document.getElementById("ai-agents");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="w-full pt-16 pb-12 sm:pt-24 sm:pb-16 lg:pt-32 py-5 overflow-hidden">
      <div className="px-4 sm:px-7 lg:px-14 xl:px-28">
        <div className="flex flex-col lg:flex-row items-start lg:items-end mb-10 lg:mb-14 gap-8 lg:gap-6">
          <div className="flex-1 text-left">
            <h1 className="font-geist-pixel text-[clamp(2.65rem,10.5vw,3.75rem)] sm:text-6xl lg:text-7xl tracking-tight-3 leading-[0.9] font-normal text-white mb-6 lg:mb-4 text-left flex flex-col gap-0">
              <span className="whitespace-nowrap">Asset Intelligence</span>
              <span className="whitespace-nowrap">for the real-world</span>
            </h1>
            <p className="text-gray-400 text-15 sm:text-base mb-8 lg:mb-7 leading-normal font-normal text-left lg:whitespace-nowrap">
              Assetilo combines asset data and AI to deliver clarity, control,
              and actionable operational insight across assets, sites, and
              teams.
            </p>
            <div className="flex items-center justify-between">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <Link
                  href="/signup"
                  className="bg-accent-primary hover:bg-accent-primary/80 text-nowrap text-white w-75 sm:w-auto max-w-full px-8 sm:px-12.5 py-3.5 sm:py-2.5 rounded-lg transition-colors text-base font-medium text-center inline-block"
                >
                  Start Using Assetilo
                </Link>
                <button
                  onClick={handleRequestDemo}
                  className="bg-transparent border border-dark-slate text-nowrap hover:border-white/20 text-white w-75 sm:w-auto max-w-full px-8 sm:px-12.5 py-3.5 sm:py-2.5 rounded-lg transition-colors text-base font-medium text-center"
                >
                  Request a Demo
                </button>
              </div>
              <div className="hidden lg:block ">
                <button
                  onClick={scrollToAIAgents}
                  className="flex items-center gap-2 text-base hover:opacity-80 transition-opacity text-left"
                >
                  <div className="underline underline-offset-4 decoration-white/30 ">
                    <span className="text-white font-bold">New:</span>{" "}
                    <span className="text-gray-400 font-medium">
                      Powerful AI Agents for Asset Management
                    </span>
                  </div>
                  <span className="text-white">↓</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pl-4 sm:pl-7 lg:pl-14 xl:px-28">
        <div className="relative w-full rounded-l-10 lg:rounded-r-10 overflow-hidden border-t border-l border-b lg:border-r border-dark-slate">
          <div className="w-275 lg:w-full">
            <OptimizedImage
              src="/assets/images/dashboard.webp"
              alt="Assetilo Dashboard Interface"
              priority={true}
              className="w-full"
              width={1600}
              height={1000}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
